import axios from "axios";
import Swal from "sweetalert2";
import * as Icons from "heroicons-react";
import { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetDamage,
  selectNote,
  selectProducts,
  selectStatus,
  selectUser,
  selectWareHouse,
} from "../../features/damageSlice";
import {
  useAddDamageMutation,
  useDamagesCountQuery,
} from "../../services/damageApi";
import { useWarehouseQuery } from "../../services/warehouseApi";
import DamageProductImpoter from "../Common/CsvImporter/DamageProductImporter";
import DamageNewProductSelect from "../Common/CustomSelect/DamageNewProductSelect";
import WareHouseDWPurchase from "../Common/CustomSelect/WareHouseDWPurchase";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import SideBar from "../Common/SideBar/SideBar";
import useDamage from "../Hooks/useDamage";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { apiUniqueErrHandle } from "../Utility/Utility";
import DamageProducts from "./DamageProducts";
// import updateInventoryOutOnDamageIn from "../Hooks/useInventory";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const DamageCreate = () => {
  const auth = signInUser();
  const { aamarId } = auth;
  let i = 1;
  const dispatch = useDispatch();
  const [wh, setWh] = useState("");
  const [onShow, setOnShow] = useState(false);
  const handleClose = () => setOnShow(false);
  // const { register, handleSubmit, isSubmitSuccessful, reset, setValue } =
  //   useForm();
  const damageNewProductsRef = useRef(null);
  const damageData = useSelector((state) => state.damageReducer);
  const [csvData, setCsvData] = useState([]);
  const [damageProducts, setDamageProducts] = useState([]);
  const navigate = useNavigate();
  // console.log(damageData);
  const [addDamage] = useAddDamageMutation();
  const [whName, setWhName] = useState("Warehouse");

  const { data: warehouseData, refetch: whRefetch } = useWarehouseQuery(
    auth?.warehouse
  );
  const { data: countData } = useDamagesCountQuery({ aamarId });
  const { totalItems } = useDamage();
  const { total_item, total, productList } = totalItems(damageProducts);
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);

  useEffect(() => {
    dispatch(selectUser(auth?.id));
  }, []);

  const handleImportButton = async () => {
    if (!csvData || csvData.length === 0) {
      notify("There is no products to import", "error");
      return;
    }

    setOnShow(true);
    try {
      const importedProducts = [];
      const notFoundCodes = [];
      let i = 1;

      for (let idx = 0; idx < csvData.length; idx++) {
        const pro = csvData[idx];
        const code = pro?.article_code ? String(pro.article_code).trim() : "";
        if (!code) continue;

        try {
          const details = await axios(
            `${BASE_URL}product/pro-details/${encodeURIComponent(code)}`
          );
          const data = details?.data;

          if (details?.status === 200 && data && data?._id) {
            const activePrice =
              data?.priceList?.find((p) => p?.status === "active") ||
              data?.priceList?.[0] ||
              {};
            const tpVal =
              activePrice?.tp !== undefined && Number(activePrice.tp) >= 0
                ? Number(activePrice.tp)
                : 0;

            importedProducts.push({
              id: data._id,
              article_code: data.article_code || code,
              priceId: activePrice?._id || data._id,
              tp: tpVal,
              name: data.name,
              qty: Number(pro?.qty) > 0 ? Number(pro.qty) : 1,
              aamarId: auth?.aamarId,
              warehouse: auth?.warehouse,
              tax: 0,
              discount: 0,
              order: pro?.order ? Number(pro.order) : i++,
            });
          } else {
            notFoundCodes.push(code);
          }
        } catch (itemErr) {
          console.error(`Error importing product ${code}:`, itemErr);
          notFoundCodes.push(code);
        }
      }

      if (importedProducts.length > 0) {
        const existingProducts = damageData?.products || [];
        const existingMap = new Map();
        existingProducts.forEach((p) => {
          existingMap.set(String(p.article_code || p.id), { ...p });
        });

        for (const item of importedProducts) {
          const key = String(item.article_code || item.id);
          if (existingMap.has(key)) {
            const existing = existingMap.get(key);
            existingMap.set(key, {
              ...existing,
              qty: Number(existing.qty || 0) + Number(item.qty || 1),
            });
          } else {
            existingMap.set(key, {
              ...item,
              order: existingMap.size + 1,
            });
          }
        }

        const mergedProducts = Array.from(existingMap.values());
        setDamageProducts(mergedProducts);
        dispatch(selectProducts(mergedProducts));
        notify(`${importedProducts.length} product(s) imported successfully!`, "success");
      }

      if (notFoundCodes.length > 0) {
        if (notFoundCodes.length <= 4) {
          notify(`Product(s) not found in store: ${notFoundCodes.join(", ")}`, "error");
        } else {
          notify(
            `${notFoundCodes.length} product(s) not found in store (e.g. ${notFoundCodes.slice(0, 3).join(", ")}...)`,
            "error"
          );
        }
      }
    } catch (err) {
      console.error("Import failed:", err);
      notify(err?.message || "Import failed", "error");
    } finally {
      setOnShow(false);
    }
  };

  console.log("Count DATA", countData);
  console.log("damageLimited", auth?.package?.damageLimited);

  const handleDamageSubmit = async () => {
    if (countData >= auth?.package?.damageLimited) {
      setModalVisible(true);
      return;
    } else {
      const reasons = (damageData?.products || [])
        .map((p) => p.reason)
        .filter((r) => r && String(r).trim() !== "");
      const combinedReason = Array.from(new Set(reasons)).join(", ");

      const newDamage = {
        ...damageData,
        reason: combinedReason,
        total: total,
      };

      if (newDamage?.products.length > 0) {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "Wanna create Damage?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, create it!",
        });

        if (result.isConfirmed) {
          try {
            // console.log("Damage Data", newDamage);
            const response = await addDamage(newDamage);
            if (response?.error?.status === 500) {
              apiUniqueErrHandle(response?.error?.data);
            } else {
              dispatch(resetDamage());
              notify("Damage Creation update successful!", "success");
            }
          } catch (err) {
            console.log(err);
          } finally {
            // setPurchaseProduct([]);
            // UPDATE INVENTORY
            navigate("/damage");
          }
        }
      } else {
        notify("There must be products for Damage", "error");
      }
    }
  };

  useEffect(() => {
    dispatch(selectWareHouse(auth?.warehouse));
    dispatch(selectUser(auth?.id));
  }, []);

  const handleOnchangeWareHouse = (e) => {
    // console.log(e);
    setWh(e.option);
    dispatch(selectWareHouse(e.option));
    dispatch(selectUser(auth?.id));
  };

  const emptyDamage = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Refresh Cart! Start New Damage?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
    });

    if (result.isConfirmed) {
      dispatch(selectProducts([]));
      localStorage.removeItem("damage_cart"); // check by manishankar please
    } else {
      // console.log("Refresh Operation Cancelled by User");
    }
  };

  const addQuantities = () => {};

  const handleCustomQty = (qty, id) => {
    // const qty = e.target.value();
    const selected = damageData?.products?.find((p) => p.article_code === id);
    const rest = damageData?.products?.filter((p) => p.article_code !== id);
    // console.log("selected", selected);
    // console.log("rest", rest);
    // console.log("id", id);
    let newProducts = [
      ...rest,
      {
        ...selected,
        qty: qty,
      },
    ];
    setDamageProducts(newProducts);
    dispatch(selectProducts(newProducts));
  };
  const handleCustomReason = (reason, id) => {
    const updated = (damageData?.products || []).map((p) =>
      p.article_code === id || p.id === id ? { ...p, reason: reason } : p
    );
    setDamageProducts(updated);
    dispatch(selectProducts(updated));
  };

  const removeQuantities = () => {};

  const addToList = async (data) => {
    // console.log(data);
    if (data) {
      // console.log("add to list:", data);
      await damageNewProductsRef.current.blur();
      let listData = damageData.products;

      let newProduct = {};
      // unique check
      const idExist = listData.find((pro) => pro.id === data._id);
      if (idExist) {
        notify("Product Already in List", "error");
        // console.log()
      } else {
        notify("Product is Added", "success");

        newProduct = {
          id: data?._id,
          name: data?.name,
          article_code: data?.article_code,
          qty: 1,
          order: listData?.length + 1,
          priceId: data?.priceList?.[0]?._id,
          tp: data?.priceList?.[0]?.tp !== undefined ? Number(data.priceList[0].tp) : 0,
          mrp: data?.priceList?.[0]?.mrp !== undefined ? Number(data.priceList[0].mrp) : 0,
          aamarId: auth?.aamarId,
          warehouse: auth?.warehouse,
          reason: "",
        };
        listData = [...listData, newProduct];
      }

      // console.log("upcoming damage:", newProduct);
      // console.log("Updated damage:", listData);
      setDamageProducts(listData);
      dispatch(selectProducts(listData));
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (auth?.warehouse) {
      whRefetch();
    }
  }, [auth?.warehouse, whRefetch]);

  useEffect(() => {
    if (warehouseData) {
      setWhName(warehouseData?.name);
      whRefetch();
    }
  }, [warehouseData, whRefetch]);
  // console.log("warehouse", warehouseData);

  const removeFromCart = (id) => {
    const selected = damageData?.products?.find((p) => p.id === id);
    const rest = damageData?.products?.filter((p) => p.id !== id);

    dispatch(selectProducts(rest));
  };
  const handleOnChangePrice = async (id, e) => {
    let newCart = [];
    // console.log(e);
    try {
      let price = await axios.get(`${BASE_URL}price/${e.option}`);
      // console.log(price);
      let selected = damageData.products.find((item) => item.id === id);
      let rest = damageData.products.filter((item) => item.id !== id);
      if (price.data) {
        newCart = [
          ...rest,
          {
            ...selected,
            tp: price.data?.tp,
            priceId: price.data?._id,
          },
        ];
        setDamageProducts(newCart);
      }
    } catch (err) {
      notify(err, "error");
    } finally {
      dispatch(selectProducts(newCart));
      // dispatch(selectProducts(newCart));
    }

    // localStorage.setItem("pos_cart", JSON.stringify(newCart));
    // console.log(e.option);
    // updateCart();
  };
  // console.log("damage create page");
  return (
    <div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10 mt-2">
            <Header title="Create Damage"></Header>
            <Form className="pt-3" action="javascript:void(0)">
              <div className="row">
                <div className="col-8">
                  <Form.Group className="" controlId="warehouse">
                    <Form.Label>Warehouse</Form.Label>
                    {auth?.type !== "admin" ? (
                      <>
                        <br />
                        {whName}
                      </>
                    ) : (
                      <WareHouseDWPurchase
                        id="warehouse"
                        name="warehouse"
                        handleOnChange={handleOnchangeWareHouse}
                        wh={wh}
                        // {...register("warehouse")}
                      />
                      
                    )}
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group className="">
                    <Form.Label>Damage Status</Form.Label>
                    <Form.Select
                      onChange={(e) => dispatch(selectStatus(e.target.value))}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-6 my-md-3">
                  <Form.Label>Damage Products</Form.Label>
                  <DamageNewProductSelect
                    className="searchProduct"
                    // getValue={getValue}
                    addToList={addToList}
                    damageNewProductsRef={damageNewProductsRef}
                  ></DamageNewProductSelect>
                </div>
                <div className="col-md-6 my-md-3 ">
                  <DamageProductImpoter
                    setCsvData={setCsvData}
                    handleImportButton={handleImportButton}
                    title=""
                  />
                </div>
                <div className="col-12 mt-3 mt-md-0">
                  <div className="card">
                    <div className="card-header">Damaged Products List</div>
                    <div className="">
                      <Table className="mt-3 ">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Name</th>
                            {/* <th>Tax</th> */}
                            <th>Quantity</th>
                            <th>TP</th>
                            {/* <th>Tax</th> */}
                            <th>Total</th>
                            <th>Reason</th>
                          </tr>
                        </thead>

                        <tbody>
                          <DamageProducts
                            damageProducts={damageData?.products}
                            i={i}
                            // removeQuantities={removeQuantities}
                            // addQuantities={addQuantities}
                            handleOnChangePrice={handleOnChangePrice}
                            handleCustomReason={handleCustomReason}
                            handleCustomQty={handleCustomQty}
                            removeFromCart={removeFromCart}
                          ></DamageProducts>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 my-2">
                  <Form.Group className="" controlId="formBasicEmail">
                    <Form.Label>Note</Form.Label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => dispatch(selectNote(e.target.value))}
                    />
                  </Form.Group>
                </div>
              </div>
              <Table className="bordered striped ">
                <thead>
                  <tr>
                    <th>Total Items:{total_item}</th>
                    <th>Damage Value: {total} TK</th>
                  </tr>
                </thead>
              </Table>
              <Button
                variant="dark"
                onClick={handleDamageSubmit}
                className="float-end my-2"
                type="button"
              >
                <Icons.SaveOutline size={20} /> Submit
              </Button>
              <Button
                variant="dark"
                className="float-end my-2 mx-2"
                type="button"
                onClick={emptyDamage}
              >
                Reset Cart
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <LoadingModal
        onShow={onShow}
        title="Please Wait.."
        handleClose={handleClose}
      />
      <Toaster position="bottom-right" />
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default DamageCreate;
